import styled from 'styled-components';
import BackgroundImage from './../../images/GUNX-WEB-FRAME.jpg'

export const HeroContainer = styled.div`
  background-image: url(${BackgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  margin-top: -80px;
  z-index: 1;
  position: fixed;
  font-family: 'Joystix Monospace', cursive;

  @media screen and (max-width: 950px) {
    overflow: scroll;
  }

`;

export const BlankDiv = styled.div`
  display: none;
`

export const HeroContent = styled.div`
  z-index: 3;
  margin-top: 180px;
  height: 100vh;
  position: absolute;
  display: inline-grid;; 
  grid-template-columns: 500px 500px;
  grid-gap: 0px;

  @media screen and (max-width: 950px) {
    display: block;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
  }
`;

export const ImageBg = styled.div`
  margin-top: 90px;
  width: 450px;
  z-index: 4;
  position: center;
  padding: auto;
  

  @media screen and (max-width: 950px) {
    margin: auto;
    width: 400px;
    margin-top: 90px;
  }

  @media screen and (max-width: 768px) {
    width: 300px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    width: 275px;
  }
 
` 

export const PreviewImage = styled.img`
  z-index: 4;
  width: 100%;
`  

export const UserWrapper = styled.div`
  height: 650px;
  padding-top: -10px;
  margin: auto;
  display: center;
  align-items: flex-start;

  @media screen and (max-width: 950px) {
    width: 400px;
    padding-top: 0;
    margin-top: -20px;
  }
`

export const HeroH1 = styled.h1`
  color: #fff;
  font-size: 20px;
  text-align: center;
  font-family: 'Joystix Monospace', cursive;

  @media screen and (max-width: 768px) {
    font-size: 30px;
  }

  @media screen and (max-width: 480px) {
    font-size: 30px;
  }
`;

export const ImageHeader = styled.div`
  z-index: 4;
  width: 100%;
  position: top;
  

  @media screen and (max-width: 950px) {
    width: 400px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 768px) {
    width: 300px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    width: 250px;
    padding: auto;
    margin: auto;
  }
`

export const PreviewImage2 = styled.img`
  z-index: 4;
  width: 110%;

  @media screen and (max-width: 768px) {
    width: 300px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    width: 350px;
    padding: auto;
    margin-top: 30px;
  }
`

export const PreviewImage3 = styled.img`
  z-index: 4;
  width: 110%;
  position: bottom;
  margin-top: 130px;

  @media screen and (max-width: 768px) {
    width: 350px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    width: 300px;
    padding: auto;
    margin: auto;
  }
`

export const HeroP = styled.p`
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: 'Joystix Monospace', cursive;
  color: #Fffced;
  font-size: 35px;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const HeroP2 = styled.p`
  color: #17fed0;
  font-family: 'Joystix Monospace', cursive;
  font-size: 22px;
  text-align: center;
  max-width: 600px;
  line-height: 100%;
  margin-bottom: 10px;
  font-kerning: none;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;

export const HeroP3 = styled.p`
  margin-top: 30px;
  color: #17fed0;
  font-family: 'Joystix Monospace', cursive;
  line-height: 5px;
  font-size: 22px;
  text-align: center;
  max-width: 600px;
  line-height: 22px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const SupplyP2 = styled.p`
  margin-top: 10px;
  color: #17fed0;
  font-size: 26px;
  font-family: 'Cursed Timer';
  text-align: center;
  max-width: 600px;
  line-height: 100%;
  font-kerning: none;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;


